import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

export default function CloneOffer({
  open,
  selectedRow,
  handleClose,
  onSubmit,
}) {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Clone Offer</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Do you want to clone "{selectedRow.name}" ?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => onSubmit(selectedRow, true, handleClose(true))}
          color="primary"
        >
          Yes
        </Button>
        <Button
          variant="contained"
          onClick={handleClose}
          color="secondary"
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}